/**
 * Simple Ajax class
 */

namespace SmartVideo {
export class Ajax {

    static ajaxSendRequest(url: string, action: string, request?: Object, callback?: Function, responseType?: string) {
        let jsonRequest = null;
        const ajax = new XMLHttpRequest();
        let ajaxurl: string;
        ajax.onload = function(e) {
            const xhr = <XMLHttpRequest>e.target;
            console.log('AJAX request to ' + url + ' returned status of: ' + xhr.status);
            if (callback) {
                callback(e);
            }
        };
        ajax.onerror = e => {
            console.log(`Failed to send ajax request ${ajaxurl}`);
            if (callback) {
                callback(e);
            }
        }
        if (request) {
            jsonRequest = JSON.stringify(request);
        }

        if (url && jsonRequest !== null && action === 'POST') {
            ajaxurl = url;
            ajax.open(action, ajaxurl, true);
            ajax.setRequestHeader('Content-Type', 'application/json');
            ajax.setRequestHeader('Accept', '*/*');
            ajax.responseType = 'json';
            ajax.send(jsonRequest);
        } else if (url && action === 'GET') {
            ajaxurl = url;
            ajax.open(action, ajaxurl, true);
            ajax.setRequestHeader('Accept', '*/*');
            // ajax.setRequestHeader("Content-Type", "application/json");
            // Allow for different response types when doing GET
            if (responseType) {
                ajax.responseType = <XMLHttpRequestResponseType>responseType;
            }
            // ajax.responseType = "json";
            ajax.send();
        } else {
            console.log('smartVideoIntegrationServiceUrl not defined');
            return;
        }
    }

    constructor() {
    }
}}
